import { put } from "@src/appV2/api/api";
import { environmentConfig } from "@src/appV2/environment";
import { useMutation, type UseMutationOptions } from "@tanstack/react-query";

import {
  type RequirementMapping,
  requirementMappingResponseSchema,
  type UpdateRequirementMappingDto,
  updateRequirementMappingSchema,
} from "../types";

export function useUpdateRequirementMapping(
  options?: UseMutationOptions<RequirementMapping, string, UpdateRequirementMappingDto>
) {
  return useMutation(async (payload: UpdateRequirementMappingDto) => {
    const response = await put({
      url: `${environmentConfig.REACT_APP_DOCUMENTS_SERVICE_REST_API_URL}/requirement-mappings/${payload.data.id}`,
      data: payload,
      requestSchema: updateRequirementMappingSchema,
      responseSchema: requirementMappingResponseSchema,
    });

    return response.data.data;
  }, options);
}
